import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type Review from 'modules/reviews/store/models/v2/Review'

interface RemindParticipantsModalProps {
  review: Review
  onClose: () => void
}

const RemindParticipantsModal = ({ review, onClose }: RemindParticipantsModalProps) => {
  const { running, performAction: remindParticipants } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      await review.remindParticipants()
      closePortal()
    }
  )

  return (
    <Modal
      illustration="send-email-envelope"
      title={i18n.t('surveys.form.configuration.stats.title')}
      description={i18n.t('surveys.form.configuration.stats.body')}
      onClose={onClose}
      onSubmit={remindParticipants}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('surveys.form.configuration.stats.title')}
          </Button>
        </>
      }
    />
  )
}

export default observer(RemindParticipantsModal)
